import { ClassItem } from './ClassItem.js';

export class Ranges {
  field: string;
  fieldAlias: string | undefined;
  classes: ClassItem[];

  /*constructor(field: string, classes: ClassItem[]) {
    this.field = field;
    this.classes = classes;
  }*/

  constructor(options: Partial<Ranges>) {
    if (typeof options.field === 'string') {
      this.field = options.field;
    } else {
      throw new Error('field is required and must be a string');
    }
    this.classes = options.classes ?? [];
    this.fieldAlias = options.fieldAlias;
  }

  public transformRangesToSteps(): any[] {
    /*
    const result: any = ['step', ['get', this.field]];
    this.classes.forEach((r: ClassItem, i) => {
      result.push(r.color);
      if (i !== this.classes.length - 1) {
        result.push(r.value);
      }
    });
    */
    const result: any = {
      property: this.field,
      stops: this.classes.map((c) => [c?.maxValue ?? c.value, c.color]),
    };
    return result;
  }

  public transformRangesToHeight(): any[] {
    const result: any = ['step', ['get', this.field]];
    this.classes.forEach((r: ClassItem, i) => {
      result.push(i * 500);
      if (i !== this.classes.length - 1) {
        result.push(r.value);
      }
    });
    return result;
  }

  public getFieldAlias(): string {
    return this.fieldAlias ? this.fieldAlias : this.field;
  }
}
